import angular from 'angular';
import MarkeplaceItemComponent from '../marketplaceItem/MarkeplaceItem.component';
import MarketplaceListComponent from './MarketplaceList.component';

export default angular
    .module('app.markeplace', ['shared'])
    .component('marketplaceItem', MarkeplaceItemComponent)
    .component('marketplaceList', MarketplaceListComponent).name;
